export const TAB_PATHS = {
    FEDERAL_FORMS: "federalforms",
    STATE_FORMS: "stateforms",
    RECONCILIATION_FORMS: "reconciliationforms",
    STATE_PAYROLL_FORMS: "statepayrollforms"
}

export const CONSENT_STATUS = {
    0: "Pending",
    1: "Accepted",
    6: "Declined",
}

export const MANAGE_FEDERAL_FORMS_STATE_FIELDS = [
    { state: "state1", filing: 'Filing1' },
    { state: "state2", filing: 'Filing2' },
    { state: "state3", filing: 'Filing3' },
    { state: "state4", filing: 'Filing4' },
];

export const FIELDS_TEXTS = {
    EMAIL_ID_TEXT: "emailId",
    TIN_TEXT: "TIN",
}

export const EXPORT_EXCEL_FIELDS = {
    SHEET_HEADINGS: ["Recipient Name", "Error"],
    MISSING_TIN_AND_EMAIL_TEXT: " |TIN and Emailid not available,",
    MISSING_TIN_TEXT: " |TIN not available,",
    MISSING_EMAIL_TEXT: " |Emailid not available, ",
    FILE_NAME: "PortalErrors.xlsx"
}

export const DOWNLOAD_PDF_COPY_OPTIONS = [
    { label: 'All Copies', value: 'all' },
    { label: 'Recipient Copy', value: 'payee' },
    { label: 'Payer Copy', value: 'payer' }
]

export const MANAGE_FORMS_LOADING_STATES = {
    FETCHING_STATES_LIST_LOADING: "FETCHING_STATES_LIST_LOADING",
    FETCHING_STATES_LIST_READY: "FETCHING_STATES_LIST_READY",
    FETCHING_FORMS_LIST_LOADING: "FETCHING_FORMS_LIST_LOADING",
    FETCHING_FORMS_LIST_READY: "FETCHING_FORMS_LIST_READY",
    FETCHING_PAYERS_LIST_LOADING: "FETCHING_PAYERS_LIST_LOADING",
    FETCHING_PAYERS_LIST_READY: "FETCHING_PAYERS_LIST_READY",
    FETCHING_GRID_RECORDS_LOADING: "FETCHING_GRID_RECORDS_LOADING",
    FETCHING_GRID_RECORDS_READY: "FETCHING_GRID_RECORDS_READY",
    FETCHING_VIEW_PDF_LOADING: "FETCHING_VIEW_PDF_LOADING",
    FETCHING_VIEW_PDF_READY: "FETCHING_VIEW_PDF_READY",
    TAX_YEARS_LOADING: "TAX_YEARS_LOADING",
    TAX_YEARS_READY: "TAX_YEARS_READY",
}

export const MANAGE_FORMS_MESSAGE_MAP = {
    [MANAGE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]: "",
    [MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]: "",
    [MANAGE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_LOADING]: "",
    [MANAGE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]: "",
    [MANAGE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LOADING]: "",
    [MANAGE_FORMS_LOADING_STATES.TAX_YEARS_LOADING]: "",
}

export const MANAGE_FEDERAL_FORMS_LOADING_STATES = {
    FORMS1099_GRID_LOADING: "FORMS1099_GRID_LOADING",
    FORMS1099_GRID_READY: "FORMS1099_GRID_READY",
    FORMS94X_GRID_LOADING: "FORMS94X_GRID_LOADING",
    FORMS94X_GRID_READY: "FORMS94X_GRID_READY",
    TAX_YEARS_LOADING: "TAX_YEARS_LOADING",
    TAX_YEARS_READY: "TAX_YEARS_READY",
}
export const MANAGE_FEDERAL_FORMS_LOADING_STATES_MESSAGE_MAP = {
    [MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING]: "",
    [MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_LOADING]: "",
    [MANAGE_FEDERAL_FORMS_LOADING_STATES.TAX_YEARS_LOADING]: "",
}

export const MANAGE_STATE_FORMS_LOADING_STATES = {
    GRID_DATA_LOADING: "GRID_DATA_LOADING",
    GRID_DATA_READY: "GRID_DATA_READY",
    STATE_FORMS_LOADING: "STATE_FORMS_LOADING",
    STATE_FORMS_READY: "STATE_FORMS_READY",
}

export const MANAGE_STATE_FORMS_LOADING_STATES_MESSAGE_MAP = {
    [MANAGE_STATE_FORMS_LOADING_STATES.GRID_DATA_LOADING]: "",
    [MANAGE_STATE_FORMS_LOADING_STATES.STATE_FORMS_LOADING]: "",
}

export const MANAGE_RECONCILIATION_LOADING_STATES = {
    RECON_STATES_LOADING: "RECON_STATES_LOADING",
    RECON_STATES_READY: "RECON_STATES_READY",
    RECON_GRID_DATA_LOADING: "RECON_GRID_DATA_LOADING",
    RECON_GRID_DATA_READY: "RECON_GRID_DATA_READY",
}

export const MANAGE_RECONCILIATION_LOADING_STATES_MESSAGE_MAP = {
    [MANAGE_RECONCILIATION_LOADING_STATES.RECON_STATES_LOADING]: "",
    [MANAGE_RECONCILIATION_LOADING_STATES.RECON_GRID_DATA_LOADING]: "",
}